/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from './sizes';

/**
 * A download icon.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function TickIcon({ className, size = 'small', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // @ts-ignore
      sx={{
        width: sizes[size],
        height: sizes[size],
        verticalAlign: 'middle',
      }}
      className={className}
      viewBox="0 0 15 15"
      fill="none"
      {...rest}
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <path
          fill="currentColor"
          fillRule="nonzero"
          d="M12.8556932 2L14.2699068 3.41421356 4.6951448 12.9889755 0.5 8.79383072 1.91421356 7.37961715 4.6951448 10.1605484z"
        ></path>
      </g>
    </svg>
  );
}
